module.exports = __webpack_public_path__ + "static/img/2787_phase_function_Paper_PointsHejduk_Prediction.248cf90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2787_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 2tzu
// module chunks = 0